/**
 * Live cross-list selection for the scouting table (SE-8316, PRD-3.8). Kept
 * in an Apollo reactive var so it survives pill switches and route changes
 * within a session, and is dropped on sign-out through `resetPerUserState`.
 * @module features/scouting/stores/watchlistSelectionStore
 */

import { makeVar } from "@apollo/client";

import {
  EMPTY_SELECTION,
  type SelectionState,
} from "@/features/scouting/utils/watchlistSelection";

/** The live selection. Read with `useReactiveVar`. */
export const watchlistSelectionVar = makeVar<SelectionState>(EMPTY_SELECTION);

/** Clears the selection (sign-out, org switch). */
export const resetWatchlistSelection = (): void => {
  watchlistSelectionVar(EMPTY_SELECTION);
};
